import axios from "axios";
import React, { useEffect, useState } from "react";
import Loading from "../Extra/Loading";
import { FaS } from "react-icons/fa6";
import StoreDashBoard from "./StoreDashBoard/StoreDashBoard";
import ProcurementOverview from "./ProcurementDashboard/ProcurementOverview";
const urlPrefix = process.env.REACT_APP_URL_PREFIX; // Fallback URL

const StoreMaster = ({ activePage }) => {
  const [procurementsDashboardData, setProcurementsDashboardData] =
    useState(null);
  const [inventoryDashboardData, setInventoryDashboardData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchInventoryData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${urlPrefix}store/get_inventory`);
      setLoading(false);
      if (response?.data?.status === "ok") {
        setInventoryDashboardData(response.data.data);
      }
    } catch (err) {
      setLoading(false);
      setError(err);
      console.error(err);
    }
  };
  const fetchProcurementData = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(
        `${urlPrefix}store/procurements/dashboard`,
      );

      setLoading(false);
      if (response?.data?.status === "ok") {
        setProcurementsDashboardData(response.data.data);
      }
    } catch (err) {
      setLoading(false);
      setError(err);
      console.error(err);
    }
  };
  useEffect(() => {
    fetchProcurementData();
    fetchInventoryData();
  }, []);

  return (
    <div>
      {loading && <Loading />}
      {inventoryDashboardData && activePage === "Inventory Dashboard" && (
        <StoreDashBoard data={inventoryDashboardData} />
      )}
      {procurementsDashboardData && activePage === "Procurement Dashboard" && (
        <ProcurementOverview data={procurementsDashboardData} />
      )}
    </div>
  );
};
export default StoreMaster;
